// Maps a challenge → a printable stamp image URL. The mobile backend
// doesn't currently return an `image_url` on the challenge model for
// seasonal/premium challenges, so the web app carries local artwork
// for the ones we support and looks them up by name.
//
// Behaviour:
//   • On the Home page seasonal card the stamp always shows (it's the
//     theming visual for the challenge).
//   • On the Challenges dashboard the stamp is only shown once the
//     challenge is claimed — before that we keep the neutral trophy /
//     lock / gift iconography.
export function getChallengeStampUrl(ch) {
  if (!ch) return null;
  const name = (ch.name || "").toLowerCase();
  if (name.includes("merdeka")) return "/assets/stamps/merdeka-2026.webp";
  return ch.image_url || ch.badge_url || ch.icon || null;
}
